import React from 'react';
const Carpenter = () => <div className="service-page"><h1>Carpenter</h1><p>Professional carpentry services for your home and office.</p></div>;
export default Carpenter;
